// js/TimerManager.js

export default class TimerManager { // Add export default
  constructor() {
    this.timerElement = document.getElementById('daily-reset-timer');
    this.intervalId = null;

    if (!this.timerElement) {
      console.warn('TimerManager: Timer display element (#daily-reset-timer) not found.');
    }
  }

  /**
   * Starts the countdown timer.
   */
  startTimer() {
    if (!this.timerElement) return; // Don't start if element is missing

    this.updateTimer(); // Update immediately

    // Only set interval if time remaining is positive and interval not already running
    if (this._getTimeRemaining() > 0 && !this.intervalId) {
      this.intervalId = setInterval(() => this.updateTimer(), 1000);
      console.log('TimerManager: Daily reset timer started.');
    } else if (this.intervalId) {
        console.log('TimerManager: Timer already running.');
    } else {
        console.log('TimerManager: Daily reset time already passed, timer not started.');
    }
  }

  /**
   * Stops the countdown timer.
   */
  stopTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      console.log('TimerManager: Timer stopped.');
    }
  }

  /**
   * Updates the timer display.
   */
  updateTimer() {
     if (!this.timerElement) return;

    try {
      const remaining = this._getTimeRemaining();
      this.timerElement.textContent = this._formatTime(remaining);

      // Stop the timer if it reaches zero
      if (remaining <= 0 && this.intervalId) {
        this.stopTimer();
        console.log("TimerManager: Daily reset time reached.");
        // Optionally, trigger a page refresh or show a message here
        // Example: document.dispatchEvent(new CustomEvent('daily-reset-reached'));
        // window.location.reload(); // Force reload
      }
    } catch (error) {
      console.error("TimerManager: Error updating timer:", error);
      this.stopTimer(); // Stop timer on error
      this.timerElement.textContent = "Error";
    }
  }

  /**
   * Calculates the time remaining until the next midnight UTC.
   * @returns {number} Milliseconds remaining.
   * @private
   */
  _getTimeRemaining() {
    const now = new Date();
    // Calculate the next midnight UTC
    const tomorrowUTC = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1));
    // Calculate the difference in milliseconds
    const remaining = tomorrowUTC.getTime() - now.getTime();
    return Math.max(0, remaining); // Ensure non-negative
  }

  /**
   * Formats milliseconds into HH:MM:SS format.
   * @param {number} ms - Milliseconds.
   * @returns {string} Formatted time string.
   * @private
   */
  _formatTime(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }
}
// Removed window export
